<div class="legend-card" [style.height]="resolvedHeight">
  <ng-container *ngIf="isSummaryPanel; else defaultPanel">
    <div
      class="deepdive-card-row"
      *ngIf="summaryCards.length; else emptySummaryBlock"
      [style.--deepdive-summary-card-width]="summaryCardWidth"
      [style.--deepdive-summary-card-min-width]="summaryCardMinWidth">
      <div class="legend-section" *ngFor="let card of summaryCards">
        <div class="legend-title">{{ card.title }}</div>
        <div class="kpi-divider"></div>
        <div class="kpi-grid">
          <ng-container *ngFor="let metric of card.metrics">
            <div class="kpi-label">{{ metric.label }}</div>
            <div
              class="kpi-value"
              [class.hot]="metric.hot"
              [class.kpi-value--hoverable]="getMetricHoverConfig(metric)"
              (mouseenter)="showMetricHover(metric, $event)"
              (mouseleave)="scheduleHideHoverCard()"
            >{{ metric.value }}</div>
            <ng-container *ngIf="metric.dividerAfter">
              <div class="kpi-subdivider"></div><div class="kpi-subdivider"></div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-template #emptySummaryBlock>
      <div class="legend-section">
        <div class="legend-title">{{ isSummaryLoading ? 'LOADING' : 'NO DATA' }}</div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #defaultPanel>
  <ng-container *ngIf="sections.length; else defaultLegendBlock">
    <div class="legend-section" *ngFor="let section of sections">
      <div class="legend-title">{{ section.title }}</div>
      <div class="legend-list">
        <div class="legend-item" *ngFor="let item of section.items">
          <span class="swatch" [ngClass]="markerShapeClass" *ngIf="item.color" [style.border-color]="item.color"></span>
          <span class="text">
            {{ item.title }}
            <span class="desc" *ngIf="item.description"> - {{ item.description }}</span>
          </span>
        </div>
      </div>
      <div class="bubble-scale" *ngIf="section.showBubbleScale">
        <span class="dot d1"></span>
        <span class="dot d2"></span>
        <span class="dot d3"></span>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultLegendBlock>
    <div class="legend-title">{{ data?.title || 'LEGENDS' }}</div>
    <div class="legend-list">
      <div class="legend-item" *ngFor="let item of legendItems">
        <span class="swatch" [ngClass]="markerShapeClass" *ngIf="item.color" [style.border-color]="item.color"></span>
        <span class="text">
          {{ item.title }}
          <span class="desc" *ngIf="item.description"> - {{ item.description }}</span>
        </span>
      </div>
    </div>
    <div class="bubble-scale" *ngIf="data?.title === 'BUBBLE SIZE'">
      <span class="dot d1"></span>
      <span class="dot d2"></span>
      <span class="dot d3"></span>
    </div>
  </ng-template>
  </ng-template>
</div>

<div
  #hoverCard
  class="legend-hover-card"
  *ngIf="hasHoverCard"
  [ngStyle]="activeHoverStyle"
  (mouseenter)="keepHoverCardOpen()"
  (mouseleave)="scheduleHideHoverCard()"
>
  <div class="legend-hover-card__loading" *ngIf="hoverChartLoading">Loading...</div>
  <div class="legend-hover-card__empty" *ngIf="!hoverChartLoading && hoverChartError">{{ hoverChartError }}</div>
  <app-line-chart
    *ngIf="!hoverChartLoading && !hoverChartError"
    [data]="activeHoverConfig"
  ></app-line-chart>
  <div class="legend-hover-card__note" *ngIf="!hoverChartLoading && !hoverChartError && activeHoverNote">
    <div class="legend-hover-card__note-line" *ngIf="activeHoverNote.name"><strong>Name:</strong> {{ activeHoverNote.name }}</div>
    <div class="legend-hover-card__note-line" *ngIf="activeHoverNote.id"><strong>ID:</strong> {{ activeHoverNote.id }}</div>
  </div>
</div>
